
(function(template){
define('vue!basicComponents/dropdown',['Vue','vuex','helpers'],function(Vue,vuex,helpers){
    return {
        template: template,
        props: ['options','options_header','hide_icon','service','service_key','userId','isComponent','activeMethod','disabled'],
        data: function(){
            return {
                showDropdown: false
            }
        },
        methods: {
            handleKeyDown: function(e,index){
                var vm = this;
                this.a11yKeyDown(e,{
                    down: function() {
                        e.preventDefault();
                        if(index == vm.options.length-1) {
                            $('.content-spaPackageTpl #app .dropdown .dropdown-options .dropdown-item.hover')[0].focus();
                        }else {
                            $('.content-spaPackageTpl #app .dropdown .dropdown-options .dropdown-item.hover')[index+1].focus();
                        }
                    },
                    up: function() {
                        e.preventDefault();
                        if(index == 0) {
                            $('.content-spaPackageTpl #app .dropdown .dropdown-options .dropdown-item.hover:last').focus();
                        }else {
                            $('.content-spaPackageTpl #app .dropdown .dropdown-options .dropdown-item.hover')[index-1].focus();
                        }
                    },
                    enter: function() {
                        e.target.click();
                        var elementToFocus = $('.content-spaPackageTpl #app #'+vm.service_key+' .service-controls .dropdown-container .dropdownIcon i');
                        if(e.target.innerHTML == vm.localStrings.sideCart.service.delete.yes) {
                            if($('.content-spaPackageTpl #app .cart-body #'+userId+' .cart-service').length > 0){
                                elementToFocus = $('.content-spaPackageTpl #app .cart-body #'+userId+' .cart-service')[0];
                            } else {
                                elementToFocus = $('.content-spaPackageTpl #app .cart-body #'+userId);
                            }
                        }
                        elementToFocus.focus();
                    },
                    escape: function() {
                        vm.showDropdown = false;
                        $('.content-spaPackageTpl #app #'+vm.service_key+' .service-controls .dropdown-container .dropdownIcon i').focus();
                    },
                    shiftTab: function(){
                        e.stopPropagation();
                    }
                })
            },
            handleClick: function(option,e){
                e.stopPropagation();
              
                this.$emit('handleDropdown-ItemClick',option,this.service,this.service_key,this.user)
                this.showDropdown = false;
                this.$store.state.mobileSuccessMessage = ""
            },
            handleIconClick: function(e){
                e.stopPropagation();
                if(this.disabled) return
                this.showDropdown = true;
            },
            hide: function(){
                if(this.showDropdown == true) this.showDropdown=false;
                if(this.activeMethod) this.emit('toggle-active-Method',null)
                //this.$parent.activeMethod = null;

            }
        },
    }
})
})('<div class="dropdown-container" v-click-outside="hide" ref="drop-down"> <span class="dropdownIcon" aria-haspopup="listbox" aria-label="dropdown" @click="handleIconClick" v-if="!hide_icon"><slot name="icon"></slot></span> <div class="dropdown" v-if="showDropdown"> <div role="listbox" class="dropdown-options" aria-label="dropdown options" v-if="isComponent"> <slot name="component" ></slot> </div> <div role="listbox" class="dropdown-options" aria-label="dropdown options" v-else> <div class="dropdown-item" v-on:click.stop="" v-if="options_header">{{options_header}}</div> <div class="dropdown-item hover" tabindex="0" @keydown="handleKeyDown($event,index)" v-for="(option,index) in options" :key="option" @click="handleClick(option,$event)">{{option}}</div> </div> </div> </div>');
